import React, { useState, useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { CHANGE_STATE_CATEGORY_QUESTION } from "../../GraphQL/Mutations";
import MaterialTable from "material-table";
import {
  GeneralStyleQuestionCategory,
  ContentLoaderQuestionCategory,
  TableConvention,
  useStylesQuestionCategories,
} from "./QuestionCategories.styled";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import { Row, Col } from "react-bootstrap";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import PortalModal from "../../Portals";
import { NotificationManager } from "react-notifications";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import { theme as themeConfig } from "../../themes/themes";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import TablePagination from "@material-ui/core/TablePagination";
import NoRecord from "../NoRecord/NoRecord";
import { AntSwitch } from "../../helpers/antSwitch";
import moment from "moment";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";

const QuestionCategories = ({
  formTrigger,
  setFormTrigger,
  setupdateData,
  showCards,
  setShowCards,
  searchBy,
}) => {
  const classes = useStylesQuestionCategories();
  const [user] = useState(getStateLoginComplete());
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [categories, setCategories] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [showLoader, setshowLoader] = useState(false);
  const [reloadRender, setreloadRender] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const rowsPerPageList = [5, 10, 20];
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dataPaginated, setDataPaginated] = useState([]);
  const [columnQuestionCategories, setColumnQuestionCategories] = useState([]);
  const [updateState] = useMutation(CHANGE_STATE_CATEGORY_QUESTION);
  const [runQueryQuestionCategories, { loading, error }] = useLazyQuery(
    ALL_QUESTION_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          let resultOfAllQuestionCategories =
            data.allCategoriesQuestion.outputData
              .map((o) => ({ ...o }))
              .sort((a, b) => b.idCategoryQuestion - a.idCategoryQuestion)
              .filter(
                (el) =>
                  el.recordState !== "Deleted" && el.description !== "Global"
              );

          setCategories(resultOfAllQuestionCategories);
          setOriginalList(resultOfAllQuestionCategories);
        }
      },
    }
  );

  useEffect(() => {
    setColumnQuestionCategories([
      {
        title: "Question ID",
        field: "idCategoryQuestion",
        type: "string",
      },
      { title: "Description", field: "description", type: "string" },
      {
        title: "Creation Date",
        type: "datetime",
        render: (rowData) => {
          return <>{moment(rowData?.createDate).format("YYYY-MM-DD")}</>;
        },
      },
      { title: "Created by", field: "createUser", type: "string" },
      {
        title: "Disable",
        field: "recordState",
        type: "string",
        cellStyle: {
          padding: "0px 16px",
        },
        render: (rowData) => {
          return (
            <FormControlLabel
              control={
                <AntSwitch
                  size="small"
                  checked={
                    rowData?.recordState.toUpperCase() === "ACTIVE"
                      ? true
                      : false
                  }
                  onChange={() => toggleChecked(rowData)}
                />
              }
            />
          );
        },
      },
      {
        title: "Action",
        field: "internal_action",
        sorting: false,
        cellStyle: {
          padding: "0px 16px",
        },
        render: (rowData) =>
          rowData && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Edit">
                  <IconButton
                    className={classes.active}
                    onClick={() => {
                      setAnchorEl(null);
                      setAnchorSelected(null);
                      setupdateData({ ...rowData });
                      setFormTrigger("question");
                    }}
                  >
                    <EditTwoTone />
                  </IconButton>
                </Tooltip>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Delete">
                  <IconButton
                    className={classes.active}
                    disabled={rowData?.recordState.toUpperCase() === "ACTIVE"}
                    onClick={() => {
                      setOpenDeleteModal(rowData);
                    }}
                  >
                    <DeleteTwoTone />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          ),
      },
    ]);
  }, [categories]);

  useEffect(() => {
    if (searchBy === "") setCategories(originalList);
    else {
      const searchResult = originalList.filter((o) =>
        Object.keys(o).some((k) =>
          o[k].toString().toLowerCase().includes(searchBy.toLowerCase())
        )
      );
      setCategories(searchResult);
    }
  }, [searchBy]);

  useEffect(() => {
    if (searchBy === "") setCategories(originalList);
    else {
      const searchResult = originalList.filter((o) =>
        Object.keys(o).some((k) =>
          o[k].toString().toLowerCase().includes(searchBy.toLowerCase())
        )
      );
      setCategories(searchResult);
    }
  }, [searchBy]);
  let updateCategoryFn = (rowData, state) => {
    setshowLoader(true);
    updateState({
      variables: {
        idCategoryQuestion: rowData.idCategoryQuestion,
        userChangeState: user.userName,
        newState: state,
      },
    })
      .then((response) => {
        setshowLoader(false);
        if (response.data.changeStateCategoryQuestion.withError === true) {
          NotificationManager.warning(
            response.data.changeStateCategoryQuestion.message,
            "",
            5000
          );
        } else {
          if (state.toUpperCase() === "DELETED") {
            categories.splice(
              categories.findIndex(
                (f) => f.idCategoryQuestion === rowData.idCategoryQuestion
              ),
              1
            );
            setCategories([...categories]);
          } else {
            rowData.recordState = state;
            NotificationManager.success(
              "The state of the category is updated successfully ",
              "",
              5000
            );
          }
          setreloadRender(!reloadRender);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let toggleChecked = (rowData) => {
    updateCategoryFn(
      rowData,
      rowData.recordState.toUpperCase() === "ACTIVE" ? "INACTIVE" : "ACTIVE"
    );
  };

  useEffect(() => {
    let startIndex = rowsPerPage * currentPage;
    setDataPaginated(categories.slice(startIndex, startIndex + rowsPerPage));
  }, [rowsPerPage, categories, currentPage]);

  let deleteSurvey = (rowData) => {
    updateCategoryFn(rowData, "DELETED");
    setOpenDeleteModal(null);
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idCategoryQuestion);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this category?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const tablePaginationListView = (props) => {
    const computedProps = { ...props };
    computedProps.style = {
      ...(computedProps?.style ?? {}),
      borderBottom: "0px",
    };
    return (
      <>
        <div style={{ display: "flex" }}>
          <div
            style={{
              display: "flex",
              width: "95%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {user && (
              <TableConvention>
                <div
                  style={{
                    background: "rgba(191, 191, 191, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Disable</p>
                <div
                  style={{
                    background: "rgba(4, 180, 105, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Active</p>
              </TableConvention>
            )}
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <table>
              <tbody>
                <tr>
                  <TablePagination {...computedProps} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    runQueryQuestionCategories();
  }, [runQueryQuestionCategories, formTrigger]);

  return (
    <GeneralStyleQuestionCategory>
      {error && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            {loading ? <PointersLine color={themeConfig.text.primary} /> : null}
            {error ? <h1>Error :(</h1> : null}
          </Col>
        </Row>
      )}
      {!loading && !showCards ? (
        <MaterialTable
          style={{ boxShadow: "none", marginLeft: "24px", marginRight: "20px" }}
          title=""
          columns={columnQuestionCategories}
          data={categories}
          options={{
            toolbar: false,
            search: false,
            maxBodyHeight: 450,
            headerStyle: {
              zIndex: 1,
              fontWeight: "bold",
            },
            cellStyle: {
              padding: "5px 10px",
            },
          }}
          components={{
            Pagination: tablePaginationListView,
          }}
        />
      ) : null}
      {(showCards || loading) && (
        <>
          <ViewControlMenu
            identity={"question-categories"}
            title={""}
            showCards={showCards}
            setShowCards={setShowCards}
            list={dataPaginated}
            toggleChecked={toggleChecked}
            handleClickActions={handleClickActions}
            anchorSelected={anchorSelected}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            setupdateData={setupdateData}
            triggerValue={"question"}
            setFormTrigger={setFormTrigger}
            isAgent={false}
          />
          {categories.length === 0 ? <NoRecord /> : null}
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                width: "95%",
                justifyContent: "flex-start",
                alignItems: "center",
                marginLeft: "1.5rem",
              }}
            >
              {user && (
                <TableConvention>
                  <div
                    style={{
                      background: "rgba(191, 191, 191, 1)",
                      height: "1em",
                      width: "1em",
                      borderRadius: "7px",
                    }}
                  ></div>
                  <p>Disable</p>
                  <div
                    style={{
                      background: "rgba(4, 180, 105, 1)",
                      height: "1em",
                      width: "1em",
                      borderRadius: "7px",
                    }}
                  ></div>
                  <p>Active</p>
                </TableConvention>
              )}
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              {categories.length > 0 ? (
                <TablePagination
                  component="div"
                  style={{ display: "flex", justifyContent: "center" }}
                  count={categories.length}
                  page={currentPage}
                  onPageChange={(e, newPage) => {
                    setCurrentPage(newPage);
                  }}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={rowsPerPageList}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(
                      parseInt(
                        event?.target?.value ? event?.target?.value : "5"
                      )
                    );
                    setCurrentPage(0);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      )}
      {showDeleteModal()}
      {(showLoader || loading) && (
        <PortalModal>
          <ContentLoaderQuestionCategory>
            <PointersLine color={themeConfig.text.primary}></PointersLine>
          </ContentLoaderQuestionCategory>
        </PortalModal>
      )}
    </GeneralStyleQuestionCategory>
  );
};
export default QuestionCategories;
